<template>
  <div id="app">
    <div class="topbar">
      OpenCollBench: Benchmarking of Collision Detection & Proximity Queries as a Web-Service
      <!-- 
        WARNING !!!
        Due to the security reason. 
        The console should be enabled only for development purpose !   
      -->
      <!--button
        class="button is-warning"
        @click="switchMode"
      >{{consoleMode == false ? 'Console':'Benchmark'}}</button-->
    </div>
    <!-- Main component from main.vue -->
    <Main class="main" v-if="!consoleMode" />
    <Console class="main" v-else />
  </div>
</template>

<script>
import Main from "./components/main";

  /* 
  WARNING !!!
  Due to the security reason. 
  The console should be enabled only for development purpose !  
  */

//import Console from "./components/console";

export default {
  name: "App",
  components: {
    Main

    /* 
    WARNING !!!
    Due to the security reason. 
    The console should be enabled only for development purpose !  
    */

    //Console
  },
  data() {
    return {
      /* 
      WARNING !!!
      Due to the security reason. 
      The console should be enabled only for development purpose !  
      */

      consoleMode: false
    };
  },
  methods: {
    /* 
    WARNING !!!
    Due to the security reason. 
    The console should be enabled only for development purpose !  
    */

    // switchMode() {
    //   this.consoleMode = !this.consoleMode;
    // }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
canvas {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
.main {
  margin-top: 49px;
  margin-bottom: -5px;
}
.topbar {
  color: aliceblue;
  width: 100%;
  font-size: 18pt;
  padding: 10px 10px 10px 10px;
  background-color: black;
  z-index: 100;
  position: fixed;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue